module.exports = __webpack_public_path__ + "static/media/2_The inner voice_SE.95de8af0.txt";